import { grey } from "@mui/material/colors";

const styles = {
  helperText: {
    mb: 0.5,
  },
  fieldContainer: {
    mb: 2,
  },
  selectSocial: {
    backgroundColor: "white",
    width: "120px",
    borderRadius: 4,
    "& fieldset.MuiOutlinedInput-notchedOutline": {
      borderColor: grey[300],
    },
  },
  linkAdornment: {
    "& .MuiTypography-root": {
      color: grey[900],
      fontSize: { xs: 12, md: 14 },
    },
  },
};

export default styles;
